import { Table, DatePicker } from "antd";
import moment from 'moment';
import DateUtil from "../../util/DateUtil";
import 'moment-timezone';
import React, { useEffect, useState } from 'react';
import SessionManager from "../../routes/SessionManager";
import LZString from 'lz-string';
import DownloadReport from "../common/DownloadReport";
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

function WindReport(props) {

    var sessionMgr = new SessionManager();
    var user = sessionMgr.readCookie('user');

    let [loading, setLoading] = useState(true);
    let [wind_recs, setWindRecs] = useState([]);
    let [coordinates, setCoordinates] = useState("");
    let [date, setDate] = useState(props.pickedDate ? props.pickedDate : moment().format("YYYY-MM-DD"));
    let timezone = user.site_selected ? user.site_selected.site_iana_timezone : moment.tz.guess()

    let report_columns = [
        {
            title: "Date",
            dataIndex: 'local_epoch',
            key: 'local_epoch',
            render: (local_epoch, rec) => moment.tz(parseInt(local_epoch) * 1000, timezone).format('MMM DD, YYYY HH:mm')
        },
        {
            title: "Wind",
            dataIndex: 'wind',
            key: 'wind',
            render: (wind, rec) => {
                return <span>{wind}</span>
            }
        },
        {
            title: "Speed(mph)",
            dataIndex: 'wind_mph',
            key: 'wind_mph',
            render: (wind_mph, rec) => wind_mph
        },
        {
            title: "Gust(mph)",
            dataIndex: 'gust_speed',
            key: 'gust_speed',
            render: (wind_mph, rec) => {
                let gust_speed = rec.wind.split(" ");
                return <span>{gust_speed[8]}</span>
            }
        },
        {
            title: "Direction",
            dataIndex: 'wind_direction',
            key: 'wind_direction',
            render: (wind_direction, rec) => {
                return <span>{wind_direction}</span>
            }
        }
    ];

    useEffect(() => {
        fetchWeatherReport();
    }, [date]);

    const fetchWeatherReport = () => {
        setLoading(true);
        let start_ts = DateUtil.getDbData(timezone, date);
        var end_date = moment(date).add(1, 'days').format('YYYY-MM-DD');
        let end_ts = DateUtil.getDbData(timezone, end_date);

        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            form_input: {
                "query": JSON.stringify({
                    attributes: ['local_epoch', 'wind', 'wind_direction', 'wind_degrees', 'wind_mph', 'json_extract(full_response, \'$.coord\') as coordinates'],
                    object: 'weather_log',
                    filters: [
                        { attribute: 'local_epoch', value: start_ts, operator: '>=' },
                        { join_by: 'and', attribute: 'local_epoch', value: end_ts, operator: '<=' }
                    ],
                    sort_by: [{ attribute: 'local_epoch', value: 'asc' }],
                    pagination: { page: 1, size: 100 }
                })
            }
        }

        CommonUtils.ajax(
            {
                url: API.DATA.EXPLORER,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let parseCoord = "";
                    if (res.data.length > 0) {
                        let coord = res.data[0].coordinates;
                        parseCoord = coord;
                    }
                    let wind_recs = [];
                    for (const wind of res.data) {
                        let windInfo = wind.wind.split(" ");
                        switch (true) {
                            case parseInt(windInfo[1]) === 0:
                                wind.wind = `From the N at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'N'
                                break;
                            case parseInt(windInfo[1]) > 0 && parseInt(windInfo[1]) < 90:
                                wind.wind = `From the NE at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'NE'
                                break;
                            case parseInt(windInfo[1]) === 90:
                                wind.wind = `From the E at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'E'
                                break;
                            case parseInt(windInfo[1]) > 90 && parseInt(windInfo[1]) < 180:
                                wind.wind = `From the SE at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'SE'
                                break;
                            case parseInt(windInfo[1]) === 180:
                                wind.wind = `From the S at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'S'
                                break;
                            case parseInt(windInfo[1]) > 180 && parseInt(windInfo[1]) < 270:
                                wind.wind = `From the SW at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'SW'
                                break;
                            case parseInt(windInfo[1]) === 270:
                                wind.wind = `From the W at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'W'
                                break;
                            case parseInt(windInfo[1]) > 270:
                                wind.wind = `From the NW at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'NW'
                                break;
                            default:
                                break;
                        }
                        wind_recs.push(wind);
                    }
                    setWindRecs(wind_recs);
                    setLoading(false);
                    setCoordinates(parseCoord);
                }
            });
    }

    const onDateChange = (date) => {
        setDate(moment(new Date(date)).format("YYYY-MM-DD"), () => {
            fetchWeatherReport(date);
        });
    }

    const getDownloadReportUrl = () => {
        let site_info = user.site_selected.site_name + "_" + Buffer.from(user.user_login).toString('base64') + "_" + date;
        var minifiedUser = preparePDFData({ ...user });
        minifiedUser.date = date;
        minifiedUser.is_today = true;
        minifiedUser.save_report = true;
        minifiedUser.request_id = "Wind Report - " + site_info + ".pdf";
        let url = API.getFullUrl('/pdf/wind-report/Wind Report - ' + site_info + '.pdf?' + LZString.compressToBase64(JSON.stringify(minifiedUser)) + '=payload&host=' + window.location.host);
        console.log('url', url);
        return url;
    }

    const preparePDFData = (userCopy) => {
        var pdfData = {};
        let flds = ["user_login", "user_token", "site_id"];
        for (let i = 0; i < flds.length; i++) {
            pdfData[flds[i]] = userCopy[flds[i]];
        }

        if (userCopy.site_selected) {
            pdfData.site_selected = {};
            let flds = ["site_id", "site_name", "site_iana_timezone"];
            for (let i = 0; i < flds.length; i++) {
                pdfData.site_selected[flds[i]] = userCopy.site_selected[flds[i]];
            }
        }

        return pdfData;
    };

    return (
        <React.Fragment>
            <div className="modal-header p-2 bg-primary text-white">
                <span className="modal-title">{props.title}</span>
                <div>
                    <button type='button' className='fa fa-expand' onClick={props.resizeModal}></button>
                    <button type='button' className='far fa-lg fa-times-circle pull-right' data-dismiss='modal' onClick={props.closeModal}></button>
                </div>
            </div>
            {!loading && (
                <div className="container px-2 bg-light">
                    <div className="row p-1">
                        <div className="col-md-4 font-weight-bold text-primary pt-1 pl-4">
                            {user && user.site_selected && user.site_selected.site_name}
                        </div>
                        <div className="col-md-8 text-right">
                            <span className='mr-2'><DownloadReport report_url={getDownloadReportUrl()}></DownloadReport></span>
                            {!props.hideDatePicker &&
                                <DatePicker
                                    allowClear={false}
                                    inputReadOnly
                                    format="YYYY-MM-DD"
                                    disabledDate={(current) => {
                                        return current.isAfter(moment());
                                    }}
                                    defaultValue={moment(date, 'YYYY-MM-DD')}
                                    showToday={false}
                                    onChange={onDateChange}
                                    popupStyle={{ zIndex: 10000 }}
                                />}
                        </div>
                    </div>
                </div>
            )}

            {!loading && coordinates && <div className="row p-1">
                <div className="col-md-6 pt-1 " style={{ paddingLeft: "32px" }}>
                    <b>Coordinates:</b>&nbsp;
                    <span className="font-size-5">
                        <label>Latitude:</label>&nbsp;<span>{coordinates.lat}, </span>
                    </span>
                    <span className="font-size-5">
                        <label>Longitude:</label>&nbsp;<span>{coordinates.lon}</span>
                    </span>
                </div>
                <div className="col-md-6 pt-1" style={{ paddingLeft: "14rem" }}>
                    <span>
                        <b>Source:</b>&nbsp;
                        <span>OpenWeather</span>
                    </span>
                </div>
            </div>}

            <div className="modal-body bg-white">
                <div className="p-1">
                    <Table
                        loading={loading}
                        rowKey="local_epoch"
                        dataSource={wind_recs}
                        columns={report_columns}
                        pagination={false}
                    />
                </div>
            </div>
        </React.Fragment>
    );
}

export default WindReport;